/* istanbul ignore file */
import React from 'react';
import classnames from 'classnames';
import Loading, { LoaderSize } from './Loading';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

type InputLoaderProps = {
  className?: string;
  sx?: SxProps<Theme>;
};

const InputLoader = ({ className = '', sx = {} }: InputLoaderProps) => (
  <Box
    data-testid="input-loader"
    className={classnames('input-loader', className)}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      '& .loading': { position: 'static', width: '20px', display: 'inline-flex' },
      ...sx,
    }}
  >
    <Loading size={LoaderSize.Small} />
  </Box>
);

export default InputLoader;
